<template>
  <div class="fm-modal-overlay" @click.self="$emit('cancel')">
    <div class="fm-modal">
      <h3 class="fm-modal-title">Agregar nueva revisión</h3>
      <p class="fm-modal-subtitle">Archivo original: <strong>{{ item.name }}</strong></p>
      <div class="fm-modal-file">
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          @change="onFileSelected"
        />
        <button class="fm-btn-select-file" @click="$refs.fileInput.click()">
          <v-icon size="18" color="currentColor">mdi-file-upload</v-icon>
          {{ file ? 'Cambiar archivo' : 'Seleccionar archivo' }}
        </button>
        <div v-if="file" class="fm-selected-file">
          <v-icon size="18" color="#5E85EF">mdi-file-document</v-icon>
          <span>{{ file.name }}</span>
          <span class="fm-file-size">{{ formatFileSize(file.size) }}</span>
        </div>
      </div>
      <div class="fm-modal-actions">
        <button class="fm-btn-cancel" @click="$emit('cancel')">Cancelar</button>
        <button class="fm-btn-confirm" :disabled="!file" @click="confirm">Subir revisión</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FMAddRevision',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      file: null
    }
  },
  methods: {
    onFileSelected(e) {
      const selectedFile = e.target.files[0]
      if (selectedFile) {
        this.file = selectedFile
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    },
    confirm() {
      if (this.file) {
        this.$emit('confirm', this.file)
      }
    }
  }
}
</script>

<style scoped>
.fm-modal-overlay {
  position: fixed; inset: 0;
  background: rgba(20,35,70,0.30); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center; z-index: 500;
}
.fm-modal {
  background: var(--fm-surface); border: 1px solid var(--fm-border2);
  border-radius: 14px; padding: 24px; min-width: 400px; max-width: 500px;
  box-shadow: var(--fm-shadow);
  animation: fm-pop 0.18s ease;
}
@keyframes fm-pop {
  from { transform: scale(0.92); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.fm-modal-title { 
  font-size: 16px; font-weight: 600; color: var(--fm-text); 
  margin-bottom: 8px; 
}
.fm-modal-subtitle {
  font-size: 13px; color: var(--fm-text2); 
  margin-bottom: 16px;
}
.fm-modal-subtitle strong {
  color: var(--fm-text); font-weight: 500;
}
.fm-modal-file {
  margin-bottom: 16px;
}
.fm-btn-select-file {
  display: flex; align-items: center; gap: 8px;
  background: var(--fm-surface2); border: 1.5px solid var(--fm-border2);
  color: var(--fm-text); font-family: var(--fm-font); font-size: 13px; font-weight: 500;
  padding: 10px 16px; border-radius: var(--fm-radius-sm); cursor: pointer;
  transition: all 0.12s; width: 100%;
  justify-content: center;
}
.fm-btn-select-file:hover {
  border-color: var(--fm-accent); color: var(--fm-accent);
}
.fm-selected-file {
  display: flex; align-items: center; gap: 8px;
  background: var(--fm-surface2); border: 1px solid var(--fm-border);
  border-radius: var(--fm-radius-sm); padding: 10px 12px;
  margin-top: 12px;
  color: var(--fm-text); font-size: 13px;
}
.fm-selected-file span:first-of-type {
  flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.fm-file-size {
  color: var(--fm-text3); font-size: 12px;
}
.fm-modal-actions { 
  display: flex; justify-content: flex-end; gap: 8px; 
}
.fm-btn-cancel {
  background: none; border: 1px solid var(--fm-border2);
  color: var(--fm-text2); font-family: var(--fm-font); font-size: 13px;
  padding: 7px 16px; border-radius: var(--fm-radius-sm); cursor: pointer;
  transition: all 0.12s;
}
.fm-btn-cancel:hover { border-color: var(--fm-border2); color: var(--fm-text); }
.fm-btn-confirm {
  background: var(--fm-accent); color: #fff; border: none;
  font-family: var(--fm-font); font-size: 13px; font-weight: 500;
  padding: 7px 16px; border-radius: var(--fm-radius-sm); cursor: pointer;
  transition: opacity 0.12s;
}
.fm-btn-confirm:hover { opacity: 0.85; }
.fm-btn-confirm:disabled { opacity: 0.4; cursor: not-allowed; }
</style>